<template>
  <div id="index-work-license-record">
    <!-- 所有上岗证 -->
    <diy_table
      :loading="loading"
      :searchData="searchData"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :tableState="true"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      searchData: this.$systemBaseData.getSearchData("workLicenseRecord"),
      tableMenu: this.$systemBaseData.getTableMenuData("workLicenseRecord"),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList(
        "workLicenseRecord",
        ""
      ),
      options: {
        professional: [],
        station: [],
        uId: [],
      },
      tempData: {},

      dialogData: {
        flag: false,
        title: "上岗证预览",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 获取专业下拉框数据
     */
    async getProfessionalList() {
      try {
        let resultData = await this.$request({
          url: "/professional/getProfessionalList",
          method: "post",
          data: { name: "" },
        });
        this.options.professional = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.professional.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取工种/岗位下拉框数据
     */
    async getListByType() {
      try {
        let resultData = await this.$request({
          url: "/dictionaries/getListByType",
          method: "post",
          data: { type: "station" },
        });
        this.options.station = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.mean,
            value: element.id,
          };
          this.options.station.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取所有下级用户列表
     */
    async getSubordinateUserList() {
      try {
        let resultData = await this.$request({
          url: "/user/getSubordinateUserList",
          method: "post",
          data: {},
        });
        this.options.uId = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.uId.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取界面数据
     */
    async initTable(data) {
      try {
        this.loading = true;
        setTimeout(async () => {
          let requestData = {};
          requestData = this.$baseData.array2json(data.searchData, requestData);
          let resultData = await this.$request({
            url: "/workLicense/getAllWorkLicenseListByLeaderUser",
            method: "post",
            data: requestData,
          });
          resultData.forEach((element) => {
            this.$set(
              element,
              "butList",
              this.$systemBaseData.getTableButtonList(
                "workLicenseRecord",
                element.status
              )
            );
          });
          this.tableData = resultData;
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        let resultData = {};
        this.tempData = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "show":
            // 查看具体学员的上岗证信息
            this.dialogData.title = "上岗证预览";
            this.dialogData.width = "550px";
            this.dialogData.dialogData = [
              { type: "work_license", value: this.tempData.workId },
            ];
            this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
            this.dialogData.flag = true;
            break;
          case "record":
            // 查看扣分记录
            resultData = await this.$request({
              url: "/workLicense/showUserWorkLicenseDeductRecord",
              method: "post",
              data: { workId: this.tempData.workId },
            });
            this.dialogData.title = "上岗证扣分";
            this.dialogData.width = "40%";
            this.dialogData.dialogData = [
              {
                value: resultData,
                type: "deduct_record",
              },
            ];
            this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
            this.dialogData.flag = true;
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    dialogOper(active) {
      try {
        switch (active) {
          case "cancel":
            this.colseDialog;
            break;

          default:
            break;
        }
      } catch (error) {}
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.getProfessionalList();
    await this.getListByType();
    await this.getSubordinateUserList();
    this.searchData.forEach((element) => {
      if (element.type == "select") {
        element.options = this.options[element.key];
      }
    });
    await this.initTable({
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#index-work-license-record {
  width: 100%;
  height: 100%;
}
</style>